<template>
  <div>
    <div class="blocklyDiv" ref="blocklyDiv"></div>
    <xml ref="blocklyToolbox" style="display: none">
      <slot></slot>
    </xml>
  </div>
</template>

<script setup>
  import { onMounted, ref, shallowRef } from 'vue'
  import * as Blockly from 'blockly/core'
  // 中文配置
  import * as Zh from 'blockly/msg/zh-hans'
  import 'blockly/blocks'

  const props = defineProps(['options'])
  const blocklyToolbox = ref()
  const blocklyDiv = ref()

  const workspace = shallowRef()
  defineExpose({workspace})

  onMounted(() => {
    Blockly.setLocale(Zh)
    const options = props.options || {}
    if (!options.toolbox) {
      options.toolbox = blocklyToolbox.value
    }
    workspace.value = Blockly.inject(blocklyDiv.value, options)
    // const onresize = function(e) {
    //   // Compute the absolute coordinates and dimensions of blocklyArea.
    //   const element = blocklyArea;
    //   let x = 0;
    //   let y = 0;
    //   do {
    //     x += element.offsetLeft;
    //     y += element.offsetTop;
    //     element = element.offsetParent;
    //   } while (element);
    //   // Position blocklyDiv over blocklyArea.
    //   blocklyDiv.style.left = x + 'px';
    //   blocklyDiv.style.top = y + 'px';
    //   blocklyDiv.style.width = blocklyArea.offsetWidth + 'px';
    //   blocklyDiv.style.height = blocklyArea.offsetHeight + 'px';
    //   Blockly.svgResize(workspace);
    // };
    // window.addEventListener('resize', onresize, false);
    // onresize();
  });

</script>

<style scoped>
  .blocklyDiv {
    height: 100%;
    width: 100%;
    text-align: left;
  }
</style>
